import React, { useState } from 'react';

export default function ShareCard({ data, onClose }) {
  const [copied, setCopied] = useState(false);
  
  // If data is null or doesn't have the required info, don't show anything
  if (!data || !data.nationality) return null;

  const { grainId, nationality, grainNumber, iso } = data;
  const shareUrl = window.location.origin;
  const shareText = `I just added a grain for ${nationality} to The Radiant Horizon! Grain ID: #${grainId || '000'}. Add yours:`;

  // Safety: Create the flag URL only if iso exists
  const flagUrl = iso ? `https://flagcdn.com/w80/${iso.toLowerCase()}.png` : null;

 const copyToClipboard = () => {
    navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    if (window.posthog) {
      window.posthog.capture('share_link_copied', {
        grainId,
        nationality,
        grainNumber
      });
    }
  };


  const socials = [
    { name: 'WhatsApp', url: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`, icon: 'WA' },
    { name: 'X', url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, icon: '𝕏' },
    { name: 'Instagram', url: `https://www.instagram.com/`, icon: 'IG' }
  ];

  return (
    <div className="sc-backdrop">
      <div className="sc-card">
        <button className="sc-close" onClick={onClose}>✕</button>
        
        <div className="sc-header">
          {flagUrl && <img src={flagUrl} alt={nationality} className="sc-flag" />}
          <div className="sc-info">
            <p className="sc-id">ID: {grainId || '---'}</p>
            <p className="sc-nat">{nationality}</p>
          </div>
        </div>

        <h2 className="sc-title">Grain #{grainNumber || '?'} Added</h2>
        <p className="sc-body">You are now part of the horizon. Show them you here to stay.</p>

        <div className="sc-actions">
          <button className={`sc-copy ${copied ? 'sc-copy--success' : ''}`} onClick={copyToClipboard}>
            {copied ? 'Link Copied' : 'Copy Share Link'}
          </button>
          
          <div className="sc-social-grid">
            {socials.map(s => (
              <a key={s.name} href={s.url} target="_blank" rel="noreferrer" className="sc-social-btn">
                <span>{s.icon}</span>
                <small>{s.name}</small>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}